import React from "react";
import ProductDisplay from "../components/New";
import Navbar from "../components/Navbar";
import HomeMobileNavbar from "../components/HomeMobileNavbar";

const Store = () => {
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}

      <h1 className="font-bdogrotesk-black text-black text-9xl px-6 py-28">
        Store
      </h1>
      <ProductDisplay isStore={true} />
    </div>
  );
};

export default Store;
